import styled from 'styled-components'

export const Established = styled.div`
    display: block;
    position: ${props => (props.tickets ? "absolute":"fixed")};
    top: 50%;
    left: 60px;
    transform: translateY(-50%);
    font-size: 10px;
    letter-spacing: 5px;
    font-family: "Bebas Kai Regular",Arial, Helvetica, sans-serif;
    transition: color .5s ease-in-out;
    z-index: 5;
    color: ${({active,light})=>light&&!active?'black':'white'};

    @media screen and (max-width: ${({theme})=>theme.breakpoints.tabletBig}){
        left: 30px;
    }
    @media screen and (max-width: ${({theme})=>theme.breakpoints.tabletSmall}){
        display: none;
    }

    &:before{
        position: absolute;
        content: "";
        height: 60px;
        width: 1px;
        top: -100px;
        left:50%;
        transition: background-color .5s ease-in-out;
        background-color: ${({active,light})=>light&&!active?'black':'white'};
        animation: anim;
        animation-duration: 3s;
    }
    @keyframes anim{
        from {
            height: 0%;
        }
        to {
            height: 60px;
        }
    }
`